import { ThemeProvider, CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { de } from 'date-fns/locale'
import { BrowserRouter } from 'react-router-dom'
import { Auth0AppProvider } from './auth/Auth0AppProvider'
import { AppQueryProvider } from './api/queryClient'
import { ErrorBoundary } from './errors/ErrorBoundary'
import { Toaster } from './errors/Toaster'
import { DevPanel } from './errors/DevPanel'
import { buildTheme } from './theme'
import { useStore } from './state/useStore'
import { type ReactNode } from 'react'

export function AppShell({ children }: { children: ReactNode }) {
  const brandColor = useStore((s) => s.personal.brandColor)
  return (
    <ThemeProvider theme={buildTheme(brandColor)}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
        <ErrorBoundary>
          <BrowserRouter>
            <Auth0AppProvider>
              <AppQueryProvider>
                {children}
                <Toaster />
                <DevPanel />
              </AppQueryProvider>
            </Auth0AppProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  )
}
